var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _UserModel_user_id, _UserModel_company_id, _UserModel_name, _UserModel_email, _UserModel_password_hash, _UserModel_phone_number, _UserModel_address, _UserModel_city, _UserModel_state, _UserModel_country, _UserModel_zipcode, _UserModel_role, _UserModel_permissions, _UserModel_fcm_tokens, _UserModel_notification_settings, _UserModel_email_notification_settings, _UserModel_created_at, _UserModel_updated_at;
import { isNotEmptyString } from './utils/validationUtilities.js';
export var UserRole;
(function (UserRole) {
    UserRole["SUPER_ADMIN"] = "super admin";
    UserRole["ADMIN"] = "admin";
    UserRole["ENGINEER"] = "engineer";
    UserRole["SHOP_FLOOR"] = "shop floor";
})(UserRole || (UserRole = {}));
export class UserModel {
    constructor(data = {}) {
        _UserModel_user_id.set(this, void 0);
        _UserModel_company_id.set(this, void 0);
        _UserModel_name.set(this, void 0);
        _UserModel_email.set(this, void 0);
        _UserModel_password_hash.set(this, void 0);
        _UserModel_phone_number.set(this, void 0);
        _UserModel_address.set(this, void 0);
        _UserModel_city.set(this, void 0);
        _UserModel_state.set(this, void 0);
        _UserModel_country.set(this, void 0);
        _UserModel_zipcode.set(this, void 0);
        _UserModel_role.set(this, void 0);
        _UserModel_permissions.set(this, void 0);
        _UserModel_fcm_tokens.set(this, void 0);
        _UserModel_notification_settings.set(this, void 0);
        _UserModel_email_notification_settings.set(this, void 0);
        _UserModel_created_at.set(this, void 0);
        _UserModel_updated_at.set(this, void 0);
        this.user_id = data.user_id || this.generateId();
        this.company_id = data.company_id || '';
        this.name = data.name || '';
        this.email = data.email || '';
        this.password_hash = data.password_hash || '';
        this.phone_number = data.phone_number || '';
        this.address = data.address || '';
        this.city = data.city || '';
        this.state = data.state || '';
        this.country = data.country || '';
        this.zipcode = data.zipcode || '';
        this.role = data.role || '';
        this.permissions = data.permissions || {};
        this.fcm_tokens = data.fcm_tokens || [];
        this.notification_settings = data.notification_settings || {
            enabled: false,
            work_orders: true,
            preventive_maintenance: true,
            safety_reports: true,
            system_alerts: false
        };
        this.email_notification_settings = data.email_notification_settings || {
            enabled: false,
            work_orders: true,
            preventive_maintenance: true,
            safety_reports: true,
            system_alerts: false
        };
        this.created_at = data.created_at || Date.now();
        this.updated_at = data.updated_at || Date.now();
    }
    // Getters and Setters
    get user_id() {
        return __classPrivateFieldGet(this, _UserModel_user_id, "f");
    }
    set user_id(user_id) {
        if (!isNotEmptyString(user_id)) {
            throw new Error('User ID is required and must be a non-empty string');
        }
        __classPrivateFieldSet(this, _UserModel_user_id, user_id, "f");
    }
    get company_id() {
        return __classPrivateFieldGet(this, _UserModel_company_id, "f");
    }
    set company_id(company_id) {
        if (!isNotEmptyString(company_id)) {
            throw new Error('Company ID is required and must be a non-empty string');
        }
        __classPrivateFieldSet(this, _UserModel_company_id, company_id, "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get name() {
        return __classPrivateFieldGet(this, _UserModel_name, "f");
    }
    set name(name) {
        if (!isNotEmptyString(name)) {
            throw new Error('Name is required and must be a non-empty string');
        }
        if (name.length > 100) {
            throw new Error('Name must be 100 characters or less');
        }
        __classPrivateFieldSet(this, _UserModel_name, name, "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get email() {
        return __classPrivateFieldGet(this, _UserModel_email, "f");
    }
    set email(email) {
        if (email.length > 100) {
            throw new Error('Email must be 100 characters or less');
        }
        __classPrivateFieldSet(this, _UserModel_email, email, "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get password_hash() {
        return __classPrivateFieldGet(this, _UserModel_password_hash, "f");
    }
    set password_hash(password_hash) {
        if (password_hash === undefined || password_hash === null) {
            // Allow undefined/null for security (when loading from Firestore)
            __classPrivateFieldSet(this, _UserModel_password_hash, '', "f");
            return;
        }
        if (password_hash.length > 255) {
            throw new Error('Password hash must be 255 characters or less');
        }
        __classPrivateFieldSet(this, _UserModel_password_hash, password_hash, "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get phone_number() {
        return __classPrivateFieldGet(this, _UserModel_phone_number, "f");
    }
    set phone_number(phone_number) {
        __classPrivateFieldSet(this, _UserModel_phone_number, phone_number, "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get address() {
        return __classPrivateFieldGet(this, _UserModel_address, "f");
    }
    set address(address) {
        __classPrivateFieldSet(this, _UserModel_address, address, "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get city() {
        return __classPrivateFieldGet(this, _UserModel_city, "f");
    }
    set city(city) {
        __classPrivateFieldSet(this, _UserModel_city, city, "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get state() {
        return __classPrivateFieldGet(this, _UserModel_state, "f");
    }
    set state(state) {
        __classPrivateFieldSet(this, _UserModel_state, state, "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get country() {
        return __classPrivateFieldGet(this, _UserModel_country, "f");
    }
    set country(country) {
        __classPrivateFieldSet(this, _UserModel_country, country, "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get zipcode() {
        return __classPrivateFieldGet(this, _UserModel_zipcode, "f");
    }
    set zipcode(zipcode) {
        __classPrivateFieldSet(this, _UserModel_zipcode, zipcode, "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get role() {
        return __classPrivateFieldGet(this, _UserModel_role, "f");
    }
    set role(role) {
        // Handle empty or undefined role
        if (!role || role.trim() === '') {
            __classPrivateFieldSet(this, _UserModel_role, '', "f");
            return;
        }
        // Normalize the role to handle case variations
        const normalizedRole = role.toLowerCase();
        if (normalizedRole === 'super admin') {
            __classPrivateFieldSet(this, _UserModel_role, UserRole.SUPER_ADMIN, "f");
        }
        else if (normalizedRole === 'admin') {
            __classPrivateFieldSet(this, _UserModel_role, UserRole.ADMIN, "f");
        }
        else if (normalizedRole === 'engineer') {
            __classPrivateFieldSet(this, _UserModel_role, UserRole.ENGINEER, "f");
        }
        else if (normalizedRole === 'shop floor' || normalizedRole === 'shopfloor') {
            __classPrivateFieldSet(this, _UserModel_role, UserRole.SHOP_FLOOR, "f");
        }
        else {
            throw new Error('Invalid role. Must be super admin, admin, engineer, or shop floor');
        }
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get created_at() {
        return __classPrivateFieldGet(this, _UserModel_created_at, "f");
    }
    set created_at(created_at) {
        if (typeof created_at !== 'number') {
            throw new Error('Created at must be a valid Unix timestamp');
        }
        __classPrivateFieldSet(this, _UserModel_created_at, created_at, "f");
    }
    get updated_at() {
        return __classPrivateFieldGet(this, _UserModel_updated_at, "f");
    }
    set updated_at(updated_at) {
        if (typeof updated_at !== 'number') {
            throw new Error('Updated at must be a valid Unix timestamp');
        }
        __classPrivateFieldSet(this, _UserModel_updated_at, updated_at, "f");
    }
    get permissions() {
        return __classPrivateFieldGet(this, _UserModel_permissions, "f");
    }
    set permissions(permissions) {
        __classPrivateFieldSet(this, _UserModel_permissions, permissions, "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get fcm_tokens() {
        return __classPrivateFieldGet(this, _UserModel_fcm_tokens, "f");
    }
    set fcm_tokens(tokens) {
        __classPrivateFieldSet(this, _UserModel_fcm_tokens, tokens || [], "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get notification_settings() {
        return __classPrivateFieldGet(this, _UserModel_notification_settings, "f");
    }
    set notification_settings(settings) {
        __classPrivateFieldSet(this, _UserModel_notification_settings, settings, "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    get email_notification_settings() {
        return __classPrivateFieldGet(this, _UserModel_email_notification_settings, "f");
    }
    set email_notification_settings(settings) {
        __classPrivateFieldSet(this, _UserModel_email_notification_settings, settings, "f");
        __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
    }
    // Static methods
    static get roles() {
        return Object.values(UserRole);
    }
    // Instance methods
    isSuperAdmin() {
        return this.role === UserRole.SUPER_ADMIN;
    }
    isAdmin() {
        return this.role === UserRole.ADMIN;
    }
    isEngineer() {
        return this.role === UserRole.ENGINEER;
    }
    isShopFloor() {
        return this.role === UserRole.SHOP_FLOOR;
    }
    hasRolePermission(requiredRole) {
        const roleHierarchy = {
            [UserRole.SUPER_ADMIN]: 4,
            [UserRole.ADMIN]: 3,
            [UserRole.ENGINEER]: 2,
            [UserRole.SHOP_FLOOR]: 1
        };
        const userRoleLevel = roleHierarchy[this.role] || 0;
        return userRoleLevel >= roleHierarchy[requiredRole];
    }
    getRoleDisplayName() {
        switch (this.role) {
            case UserRole.SUPER_ADMIN:
                return 'Super Administrator';
            case UserRole.ADMIN:
                return 'Administrator';
            case UserRole.ENGINEER:
                return 'Engineer';
            case UserRole.SHOP_FLOOR:
                return 'Shop Floor';
            default:
                return 'Unknown';
        }
    }
    // Permission helper methods
    hasPermission(resource, action) {
        if (this.isSuperAdmin()) {
            return true; // Super admin has all permissions
        }
        const resourcePermissions = this.permissions[resource];
        return resourcePermissions ? resourcePermissions.includes(action) : false;
    }
    canRead(resource) {
        return this.hasPermission(resource, 'read');
    }
    canWrite(resource) {
        return this.hasPermission(resource, 'write');
    }
    canDelete(resource) {
        return this.hasPermission(resource, 'delete');
    }
    addPermission(resource, action) {
        if (!this.permissions[resource]) {
            this.permissions[resource] = [];
        }
        if (!this.permissions[resource].includes(action)) {
            this.permissions[resource].push(action);
            __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
        }
    }
    removePermission(resource, action) {
        if (this.permissions[resource]) {
            this.permissions[resource] = this.permissions[resource].filter(perm => perm !== action);
            __classPrivateFieldSet(this, _UserModel_updated_at, Date.now(), "f");
        }
    }
    toJSON() {
        return {
            user_id: this.user_id,
            company_id: this.company_id,
            name: this.name,
            email: this.email,
            phone_number: this.phone_number,
            address: this.address,
            city: this.city,
            state: this.state,
            country: this.country,
            zipcode: this.zipcode,
            role: this.role,
            permissions: this.permissions,
            fcm_tokens: this.fcm_tokens,
            notification_settings: this.notification_settings,
            email_notification_settings: this.email_notification_settings,
            created_at: this.created_at,
            updated_at: this.updated_at
        };
    }
    toFirestore() {
        return {
            user_id: this.user_id,
            company_id: this.company_id,
            name: this.name,
            email: this.email,
            password_hash: this.password_hash,
            phone_number: this.phone_number,
            address: this.address,
            city: this.city,
            state: this.state,
            country: this.country,
            zipcode: this.zipcode,
            role: this.role,
            permissions: this.permissions,
            fcm_tokens: this.fcm_tokens,
            notification_settings: this.notification_settings,
            email_notification_settings: this.email_notification_settings,
            created_at: this.created_at,
            updated_at: this.updated_at
        };
    }
    generateId() {
        return `user_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }
}
_UserModel_user_id = new WeakMap(), _UserModel_company_id = new WeakMap(), _UserModel_name = new WeakMap(), _UserModel_email = new WeakMap(), _UserModel_password_hash = new WeakMap(), _UserModel_phone_number = new WeakMap(), _UserModel_address = new WeakMap(), _UserModel_city = new WeakMap(), _UserModel_state = new WeakMap(), _UserModel_country = new WeakMap(), _UserModel_zipcode = new WeakMap(), _UserModel_role = new WeakMap(), _UserModel_permissions = new WeakMap(), _UserModel_fcm_tokens = new WeakMap(), _UserModel_notification_settings = new WeakMap(), _UserModel_email_notification_settings = new WeakMap(), _UserModel_created_at = new WeakMap(), _UserModel_updated_at = new WeakMap();
//# sourceMappingURL=UserModel.js.map